// Handle employee image errors
function employeeImgError (image) {
  if (!image) return false
  if (image.src) {
    let srcReplaced = image.src.replace(/square\-(\d+)/gi, 'width-$1')
    if (srcReplaced !== image.src) {
      image.src = srcReplaced
    }
  }
  image.onerror = "employeeImgErrorPlaceholder(this);"
  return true
}
window.employeeImgError = employeeImgError // Has to be global

function employeeImgErrorPlaceholder (image) {
  if (!image) return false
  if (employeeImagePlaceholder) {
    if (employeeImagePlaceholder !== image.src) {
      image.src = employeeImagePlaceholder
    }
  }
  image.onerror = ""
  return true
}
window.employeeImgErrorPlaceholder = employeeImgErrorPlaceholder // Has to be global

// Debounce helper function
function debounce(func, wait) {
    let timeout
    return function executedFunction(...args) {
        const later = () => {
            clearTimeout(timeout)
            func(...args)
        };
        clearTimeout(timeout)
        timeout = setTimeout(later, wait)
    }
}

// Unwrap HTML elements helper function
function unwrapElement (selector, baseElement = null) {
  var nodelist = (baseElement || document).querySelectorAll(selector);
  Array.prototype.forEach.call(nodelist, function (item) {
    item.outerHTML = item.innerHTML
  })
}

// On page load
document.addEventListener('DOMContentLoaded', function (event) {

  // Handle office contact html anchor tags
  unwrapElement('.info-block-contact a')

  /* search-employee-offices part-related code - BEGIN*/

  // The searchText input
  const searchQueryInput = document.getElementById('search-employee-offices-query')

  // The example link
  const searchGoToSearchLink = document.getElementById('search-employee-go-to-search')
  searchGoToSearchLink && searchGoToSearchLink.addEventListener('click', function (e) {
    e.preventDefault()
    searchQueryInput && searchQueryInput.focus()
    return false
  })

  // The search button
  const searchSubmitButton = document.getElementById('search-employee-offices-submit')

  // Watch for Enter key and trigger submit
  if (searchQueryInput && searchSubmitButton) {
    const searchHandleSubmit = debounce(() => {
        searchSubmitButton.click()
    }, 200)

    searchQueryInput.addEventListener('keypress', (event) => {
        if (event.key === 'Enter') {
            event.preventDefault()
            searchHandleSubmit()
            return false
        }
    })
  }

  searchSubmitButton && searchSubmitButton.addEventListener('click', searchQuerySubmit)

  window.searchQuerySubmitClicked = false;
  function searchQuerySubmit (e) {
    e.preventDefault()
    if (!window.searchQuerySubmitClicked) { // Check lock
      window.searchQuerySubmitClicked = true; // Start lock
      const inputContainer = document.querySelector('.search-employee-offices__input')
      const searchLoadingOverlay = document.getElementById('search-employee-offices-loading-overlay')
      inputContainer.classList.add('search-employee-offices__input-wait')
      if (searchLoadingOverlay) {
        searchLoadingOverlay.classList.remove('hidden')
      }

      const query = (searchQueryInput && searchQueryInput.value.trim()) || ''
      const findEmployeesPageUrl = searchSubmitButton && searchSubmitButton.getAttribute('data-find-employees-page-url')

      if (findEmployeesPageUrl) {
        const url = new URL(findEmployeesPageUrl)

        if (query.length > 0) {
          url.searchParams.append('searchText', query)
        }

        setTimeout(() => {
          window.location.href = url.toString()
        }, 150)
      }

      setTimeout(() => {
        inputContainer.classList.remove('search-employee-offices__input-wait')
        const searchLoadingOverlayCleanup = document.getElementById('search-employee-offices-loading-overlay')
        if (searchLoadingOverlayCleanup) {
          searchLoadingOverlayCleanup.classList.add('hidden')
        }
        window.searchQuerySubmitClicked = false; // Reset lock
      }, 15000)
    }
    return false
  }

  /* search-employee-offices part-related code - END */

  /* list-employee-offices part-related code - BEGIN*/

  // The searchText input
  const listQueryInput = document.getElementById('list-employee-offices-query')

  // The loading overlay
  const listLoadingOverlay = document.getElementById('list-employee-offices-loading-overlay')

  // The example and retry links
  const listGoToSearchLink = document.getElementById('list-employee-go-to-search')
  const listRetryLink = document.getElementById('list-employee-retry')
  const linksToAddListener = [listGoToSearchLink, listRetryLink]
  linksToAddListener.forEach(link => {
    link && link.addEventListener('click', function (e) {
      e.preventDefault()
      listQueryInput && listQueryInput.focus()
      return false
    })
  })

  // The search button
  const listSubmitButton = document.getElementById('list-employee-offices-submit')

  // Watch for Enter key and trigger submit
  if (listQueryInput && listSubmitButton) {
    const listHandleSubmit = debounce(() => {
        listSubmitButton.click()
    }, 200)

    listQueryInput.addEventListener('keypress', (event) => {
        if (event.key === 'Enter') {
            event.preventDefault()
            listHandleSubmit()
            return false
        }
    })
  }

  listSubmitButton && listSubmitButton.addEventListener('click', listQuerySubmit)

  window.listQuerySubmitClicked = false;
  function listQuerySubmit (e) {
    e.preventDefault()
    if (!window.listQuerySubmitClicked) { // Check lock
      window.listQuerySubmitClicked = true; // Start lock
      const inputContainer = document.querySelector('.list-employee-offices__input')
      inputContainer.classList.add('list-employee-offices__input-wait')
      if (listLoadingOverlay) {
        listLoadingOverlay.classList.remove('hidden')
      }

      const query = (listQueryInput && listQueryInput.value.trim()) || ''
      const findEmployeesPageUrl = listSubmitButton && listSubmitButton.getAttribute('data-find-employees-page-url')

      if (findEmployeesPageUrl) {
        const url = new URL(findEmployeesPageUrl)

        if (query.length > 0) {
          url.searchParams.append('searchText', query)
          document.querySelector('.list-employee-offices__input-example.input-without-search').classList.add('hidden')
          document.querySelector('.list-employee-offices__input-example.input-with-search').classList.remove('hidden')
        } else {
          document.querySelector('.list-employee-offices__input-example.input-without-search').classList.remove('hidden')
          document.querySelector('.list-employee-offices__input-example.input-with-search').classList.add('hidden')
        }

        const fetchError = function () {
          const employeesContainerElem = document.getElementById('list-employee-offices-employees-container')
          const officesContainerElem = document.getElementById('list-employee-offices-offices-container')
          const errorContainerElem = document.getElementById('list-employee-offices-error-container')
          const searchCountElem = document.getElementById('list-employee-offices-search-count')

          // Show error container only and set search count to 0
          employeesContainerElem.classList.add('hidden')
          officesContainerElem.classList.add('hidden')
          errorContainerElem.classList.remove('hidden')
          searchCountElem.textContent = '0'
        }

        fetch(url.toString(), {
          method: 'GET',
          redirect: 'follow',
          referrerPolicy: 'no-referrer'
        }).then(response => {
          if (response.status !== 200) {
            fetchError()
            return ''
          }
          return response.text()
        }).then(htmlText => {
          if (!htmlText) return

          const employeesContainerElem = document.getElementById('list-employee-offices-employees-container')
          const officesContainerElem = document.getElementById('list-employee-offices-offices-container')
          const errorContainerElem = document.getElementById('list-employee-offices-error-container')
          const searchCountElem = document.getElementById('list-employee-offices-search-count')

          const parser = new DOMParser()
          const newDocument = parser.parseFromString(htmlText, 'text/html')

          // Handle office contact html anchor tags
          unwrapElement('.info-block-contact a', newDocument)

          const newEmployeesContainerElem = newDocument.getElementById(employeesContainerElem.id)
          employeesContainerElem.replaceWith(newEmployeesContainerElem)
          const newOfficesContainerElem = newDocument.getElementById(officesContainerElem.id)
          officesContainerElem.replaceWith(newOfficesContainerElem)
          const newErrorContainerElem = newDocument.getElementById(errorContainerElem.id)
          errorContainerElem.replaceWith(newErrorContainerElem)
          const newSearchCountElem = newDocument.getElementById(searchCountElem.id)
          searchCountElem.textContent = newSearchCountElem.textContent
        }).catch(() => {
          fetchError()
        }).finally(() => {
          inputContainer.classList.remove('list-employee-offices__input-wait')
          if (listLoadingOverlay) {
            listLoadingOverlay.classList.add('hidden')
          }
          window.listQuerySubmitClicked = false; // Reset lock
        })
      } else {
        inputContainer.classList.remove('list-employee-offices__input-wait')
        if (listLoadingOverlay) {
          listLoadingOverlay.classList.add('hidden')
        }
        window.listQuerySubmitClicked = false; // Reset lock
      }
    }
    return false
  }
  /* list-employee-offices part-related code - END */
})
